import React, { useCallback } from "react";
import { omit } from "lodash";
import classNames from "classnames";
import { Switch } from "@blueprintjs/core";
import { Tooltip } from "@blueprintjs/core";
import * as styles from "./styles.module.scss";
const ToggleButtonInput = ({ title, showTooltipIfDisabled, position, className, children, onChange, value, alignIndicator, disabled = false, autoFocus, }) => {
    const onToggleButtonChange = useCallback((e) => {
        const isChecked = e.target.checked;
        !!onChange && onChange(isChecked);
    }, [onChange]);
    return (React.createElement(Tooltip, { key: title, content: title, minimal: true, openOnTargetFocus: false, placement: position || "left", disabled: (disabled && !showTooltipIfDisabled) || !title, renderTarget: (props) => {
            const { ...restProps } = props;
            return (React.createElement("div", { ...omit(restProps, "isOpen"), className: classNames(className, restProps.className) },
                React.createElement(Switch, { checked: value, large: true, disabled: disabled, className: styles.root, onChange: onToggleButtonChange, alignIndicator: alignIndicator, autoFocus: autoFocus }, children)));
        }, portalClassName: styles.tooltipPortal, popoverClassName: styles.tooltip }));
};
export default ToggleButtonInput;
